import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useMessage } from "./ExpertMessageHook";
// Set the default state values for each context
const ExpertMessageContext = /*#__PURE__*/createContext({});
export const ExpertMessageContextProvider = ({
  children
}) => {
  const messageContext = useMessage();
  const {
    stateTracker
  } = useDevLogging();

  /**
   * useMemo ensures that expertMessageContext is preserved unless certain state objects change value
   * this prevent unecessary re-renders
   */
  const expertMessageContext = useMemo(() => {
    stateTracker.trackState({
      message: messageContext.message
    });
    stateTracker.trackState({
      messageResources: messageContext.messageResources
    });
    return {
      ...messageContext
    };
  }, [messageContext.message, messageContext.messageResources, messageContext.dialogueError, messageContext.dialogueNote, messageContext.corruptUserSession, messageContext.customerSecureData, messageContext.responseCodeError, messageContext.isButtonVisible]);

  // pass the value in provider and return
  return /*#__PURE__*/React.createElement(ExpertMessageContext.Provider, {
    value: expertMessageContext
  }, children);
};
export const useExpertMessageContext = () => {
  return useContext(ExpertMessageContext);
};
ExpertMessageContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};